import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { differenceInCalendarDays } from 'date-fns';
import * as moment from 'moment';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { AuthService } from 'src/app/auth/auth.service';
 import { MerchantSearch } from 'src/app/models/merchant';
import { Product } from 'src/app/models/product';
import { productTypeOptions, statusForProduct, UserStatus } from 'src/app/utilities/common-file';
import { Messages } from 'src/app/utilities/message';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { ProductService } from '../../product.service';
import { encryptStorage } from '../../products.component';
import * as urls from "src/app/utilities/urls";
 


@Component({
  selector: 'app-create-merchant-product',
  templateUrl: './create-merchant-product.component.html'
})
export class CreateMerchantProductComponent implements OnInit {
  fileList = [];
  merchantId:number;
  documentImage: any;
  documentImageName: any;
  previewVisible = false;
  previewImage: string | undefined = '';
  showUploadList = {
  showPreviewIcon: true,
  showRemoveIcon: true,
  hidePreviewIconInNonImage: true
  };
  status=UserStatus;
  dateFormat = 'yyyy-MM-dd';
  today = new Date();
  productForm: UntypedFormGroup;
  amounts: any;
   removeItems:any;
  currentItems:any;
 productCategoryIds:any;
  // For App Code
  showAppCodeFilter = false;
  appCodeOptions = [];
  categoryOptions:any;
  statusForProduct = statusForProduct;
  productTypeOptions = productTypeOptions;
  merchantModal: NzModalRef;
  isThumbnailImage = false;
  thumbnailImageSrc: string;
  thumbnailImage: any;
  thumbnailImageName: any;
  imageId: any;
  thumbnailImageId: any;
  upload:any;

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onSavedProduct = new EventEmitter<any>();
  @Output() onEditProduct = new EventEmitter<any>();
  @Input() selectedProduct: any;
  @Input() productId: any;
  @Input() buttonLoading = false;
  @Input() buttonLoadingForUpdate = false;
  loadingData: boolean = false;
  private merchanttableData: NzTableData<MerchantSearch, any> = new NzTableData<MerchantSearch, any>(new MerchantSearch(), 'fullName');
  optionsLoading: boolean = false;

  // productId: any;

  // tslint:disable-next-line: max-line-length
  constructor(
    private fb: UntypedFormBuilder,
     private modal: NzModalService,
    private notification: NzNotificationService,
    private drawerRef: NzDrawerRef<string>,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private productService: ProductService,
    private modalService: NzModalService
  ) {
    this.productForm = this.fb.group({
      id: [""],
      merchantId: [""],
      name: ["",Validators.required],
      productCategoryId:[[],Validators.required],
      merchantName: ["",],
      code: ["", Validators.required],
      appCode: [""],
      description: [""],
      additionalNotes: [""],
      price: ["", Validators.required]
    });
  }
  // tslint:disable-next-line: use-lifecycle-interface
   ngOnInit() {
    this.productId = parseInt(this.productId);
     this.getCategoryList();
    if (this.selectedProduct) {
      this.productForm.patchValue(this.selectedProduct);
      this.productCategoryIds=this.selectedProduct.productCategoryId ? this.selectedProduct.productCategoryId.split(',').map(Number):[];
      this.productForm.controls.productCategoryId.setValue(this.productCategoryIds);
      this.getProductImageList(this.selectedProduct.id);
      this.thumbnailImageName = this.selectedProduct.thumbnailImage;
      this.thumbnailImage = this.selectedProduct.thumbnailImage;
      if (this.thumbnailImageName) {
        this.isThumbnailImage = true;
      }

    }
  }
// For Page Index change
onIndexChange(event) {
  this.merchanttableData.pageIndex = event;
  this.getMerchants(false);
}

  getProductImageList(productId){
    const value={
     productId:productId,
     merchantId:this.selectedProduct.merchantId,
     pageSize: 10,
     pageIndex:1
   }
   this.productService.getImageList(value).subscribe((res:any) => {
      let imageLists = res.data.merchantProductImages;
     this.fileList=[];
     for(let i=0;i<imageLists.length;i++){
     this.productService.getBlobImage(imageLists[i]).subscribe((res:any)=>{
       const file = new File([res], imageLists[i].imageName, { type: res.type });
       const images = {
         originFileObj: file,
         id:imageLists[i].id,
         isUpload:false
       };
       this.fileList = this.fileList.concat(images);
     });
     }
    }, error => {
      this.buttonLoading = false;
   });
 }
  // Check for Date Validation
  checkDateValidation() {
    const d1 = moment(this.productForm.value.startDate).utc().valueOf();
    const d2 = moment(this.productForm.value.endDate).utc().valueOf();

    if ((d2 > d1) || (d2 === d1)) {
      return true;
    } else {
      this.notification.error('End Date must be greater than start date', '', {
        nzKey: 'key'
      });
      return false;
    }
  }
   // Preview Image
 handlePreview = (file: NzUploadFile) => {
  this.previewImage = file.url || file.thumbUrl;
  this.previewVisible = true;
}

  // To Create new Product
  saveProduct() {
    this.validationCheck();
    // this.productForm.value.productId = this.productId;
    if (this.productForm.valid) {
      if (this.thumbnailImage) {
      this.createProduct();
    } else {
      this.notification.error('Please upload thumbnail image', "", {
        nzKey: "key",
      });
    }
    } else {
      this.buttonLoading = false;
      for (const i in this.productForm.controls) {
        this.productForm.controls[i].markAsDirty();
        this.productForm.controls[i].updateValueAndValidity();
        this.notification.error(Messages.error, '', {
          nzKey: 'key',
        });
      }
    }
  }
 validationCheck(){
  if (this.productForm.value.description) {
    this.productForm.controls['description'].setValidators([Validators.maxLength(500)]);
  }
  if(this.productForm.value.additionalNotes){
    this.productForm.controls['additionalNotes'].setValidators([Validators.maxLength(500)]);
  }
 }
  // Create New Product
  createProduct() {
    let price = this.productForm.value.price;
    if (this.productForm.valid && (price > 0)) {
      this.buttonLoading = true;
      this.productForm.controls.merchantId.setValue(+encryptStorage.getItem('merchantId'));
      this.productForm.controls.merchantName.setValue(encryptStorage.getItem('merchantName'));
      this.productForm.controls.appCode.setValue(this.authService.getAppCode());
      this.productService.createMerchantProduct(this.productForm.value).subscribe(
        (res:any) => {
          // this.notification.success(Messages.saved, '', {
          //   nzKey: 'key',
          // });
          this.uploadImage(res.data.id, 'create');
          this.uploadFormData(res.data.id,this.fileList);
          this.LinkMerchantProductToCategory(res.data.id);
          // this.onSavedProduct.emit(res as Product);
        },
        (error) => {
          this.buttonLoading = false;
        });

    } else {
      if(price < 1){
        this.notification.error('Offer Price should always be greater than 0.', '', {
          nzKey: 'key'
          });
      }
      this.buttonLoading = false;
    }
  }
  LinkMerchantProductToCategory(productId){
    const value={
      appCode:this.productForm.value.appCode,
      merchantId:this.productForm.value.merchantId,
      productId:productId,
      categoryIds:this.productForm.value.productCategoryId
       }
       this.productService.createMerchantProductCategory(value).subscribe((response: any) => {
      }, (err) => {  
       });
    }
    updateLinkMerchantProductToCategory(productId){
      let Id=this.productForm.value.id;
      const value={
      productId:productId,
      appCode:this.productForm.value.appCode,
      merchantId:this.productForm.value.merchantId,
       }
       this.appendCategory(value);
    this.productService.updateMerchantProductCategory(value).subscribe((response: any) => {
       }, (err) => {  
       });
    }
    remove(value: any) {
      [this.removeItems] = [this.productForm.value.productCategoryId];
     }
     onChange(event:any){
     [this.currentItems] = [this.productForm.value.productCategoryId];
     if(this.selectedProduct){
       let deletedId = this.removeItems ? this.removeItems.filter(x=>this.currentItems.indexOf(x)==-1) : '';
       if(deletedId){
        this.deleteCategory(deletedId[0]);
        }
     }
     }
     deleteCategory(Id){
     let isSavedId=this.productCategoryIds.includes(Id);
     if(isSavedId){
       const value={
         productId:this.selectedProduct.id,
         appCode:this.productForm.value.appCode,
         merchantId:this.productForm.value.merchantId,
         status:this.status.Deleted,
         categoryIds:[Id]
          }
          this.productService.updateMerchantProductCategory(value).subscribe((response: any) => {
         }, () => {  
          });
     }
     }
    deleteLinkMerchantProductToCategory(Id){
       const value={
      productId:Id,
      appCode:this.productForm.value.appCode,
      merchantId:this.productForm.value.merchantId,
      status:this.status.Deleted
       }
       this.appendCategory(value);
     this.productService.updateMerchantProductCategory(value).subscribe((response: any) => {
      this.deleteProduct(Id);
    }, () => {  
       });
    }
    appendCategory(value){
      if(this.productForm.value.productCategoryId.length === 1){
       value.categoryId=this.productForm.value.productCategoryId[0];
      }
      else{
        value.categoryIds = this.productForm.value.productCategoryId;
      }
    }
  // To Update a Product
  editProduct() {
    this.validationCheck();
    if (this.productForm.valid) {
      if (this.thumbnailImage && this.thumbnailImageName) {
      this.updateProduct();
    } else {
      this.notification.error('Please upload thumbnail image', "", {
        nzKey: "key",
      });
    }

    } else {
      this.buttonLoadingForUpdate = false;
      // tslint:disable-next-line: forin
      for (const i in this.productForm.controls) {
        this.productForm.controls[i].markAsDirty();
        this.productForm.controls[i].updateValueAndValidity();
        this.notification.error(Messages.error, '', {
          nzKey: 'key',
        });
      }
    }
  }

  // Update Product
  updateProduct() {
    let price = this.productForm.value.price;
    if (this.productForm.valid && (price > 0)) {
      this.buttonLoadingForUpdate = true;
      this.productService.editMerchantProduct(this.selectedProduct.id, this.productForm.value).subscribe(
        (res:any) => { 
          this.notification.success(Messages.updated, '', {
            nzKey: 'key',
          });
          if(this.fileList.length > 0){
            this.uploadFormData(this.selectedProduct.id,this.fileList);
           }
           this.updateLinkMerchantProductToCategory(res.data.id);
           this.onEditProduct.emit(res as Product);
        },
        (error) => {
          this.buttonLoadingForUpdate = false;
        });
    } else {
      if(price < 1){
        this.notification.error('Offer Price should always be greater than 0.', '', {
          nzKey: 'key'
          });
      }
      this.buttonLoading = false;
    }
  }

  // Delete Popup confirmation
  showDeleteConfirm() {
    this.modal.confirm({
      nzTitle: 'Are you sure you want to delete this product?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.deleteLinkMerchantProductToCategory(this.selectedProduct.id),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel'),
    });
  }
  // Delete API request
  deleteProduct(Id) {
    this.productService.deleteMerchantProduct(Id).subscribe((res) => {
      this.notification.success(Messages.deleted, '', {
        nzKey: 'key',
      });
       this.onEditProduct.emit(res);
    });
  }

  // To Disable Past dates in datepicker for Start and end Date fields
  disabledPastDate = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) < 0;
  }
  // To Close drawer
  close(){ 
    let categoryIds = this.productForm.value.productCategoryId;
    let isValid = categoryIds ? categoryIds.filter(x=>this.productCategoryIds.indexOf(x)==-1) : '';
    if((!isValid[0]) && categoryIds[0]){
      this.drawerRef.close();
      this.productService.refreshMerchantProductList(true);
    }else{
      this.notification.error(Messages.error, '', {
        nzKey: 'key',
      });
    }
  }

  // Modal Pop up to Chose Appcode
  createTplModal(
    tplTitle: TemplateRef<{}>,
    tplContent: TemplateRef<{}>,
    tplFooter: TemplateRef<{}>
  ) {
    if (this.productForm.value.merchantName) {
      if (this.productForm.value.appCode) {
        this.getMerchants();
        this.merchantModal = this.modal.create({
          nzTitle: tplTitle,
          nzContent: tplContent,
          nzFooter: tplFooter,
          nzClassName:'modalStyle',
          nzMaskClosable: false,
          nzClosable: false,
          nzWidth: '40%',
          nzOnOk: () => console.log('Click ok'),
        });
      }
    } else {
      this.notification.error(Messages.validateForMerchantName, "", {
        nzKey: "key",
      });

    }
  }

  // For merchant list 
  getMerchants(startFromPageOne: boolean = true): void {
    this.loadingData = true;
    this.merchanttableData.data = [];
    if (startFromPageOne) {
      this.merchanttableData.pageIndex = 1;
    }
    this.merchanttableData.pageSize = 5;
     this.merchanttableData.search.name = this.productForm.value.merchantName;
    this.productService.getMerchantsWithLimit(this.merchanttableData).subscribe((response: any) => {
      this.loadingData = false;
      this.merchanttableData.total = response.data.total;
      this.merchanttableData.data = response.data.merchants;
    }, () => {
      this.loadingData = false;
    });
  }

  selectMerchantName(row): void {
    this.productForm.controls.merchantName.setValue(row.name);
    this.productForm.controls.merchantId.setValue(row.id);
    this.destroyModal();
  }

  destroyModal() {
    this.merchantModal.destroy();
  }
 // Delete KYC Document Image confirmation
removeFileImage = (file: NzUploadXHRArgs) => {
  this.modalService.confirm({
    nzTitle: 'Are you sure you want to delete this image?',
    nzOkText: 'Yes',
    nzOkType: 'danger',
    nzOnOk: () => this.deleteProductImage(file),
    nzCancelText: 'No',
    nzOnCancel: () => console.log('Cancel')
  });
}
// Delete Product
deleteProductImage(file) {

  if(file.isUpload){
   for(let item of this.fileList){
    if(item.id === file.id){
   var index = this.fileList.indexOf(item);
   this.fileList.splice(index,1);
   } 
  }
  let tempList = this.fileList;
  this.fileList=[];
  this.fileList=[...tempList]
  }
 else{
  this.notification.info('Processing', 'Please Wait', {
    nzKey: 'key'
  });
   this.productService.deleteMerchantProductImage(file).subscribe((response: any) => {
     this.notification.success(Messages.deleted, '', {
       nzKey: 'key'
     });
     for(let item of this.fileList){
       if(item.id === file.id){
       var index = this.fileList.indexOf(item);
       this.fileList.splice(index,1);
       } 
      }
      let tempList = this.fileList;
      this.fileList=[];
      this.fileList=[...tempList]
      }, (err) => {
   });
 }
}
// For uploading image document
customReqForDocumentUpload = (item: NzUploadXHRArgs) => {
    this.documentImageName = item.file.name;
  {{ this.documentImageName}}
    const imageObj = {
      originFileObj: item.file,
      status: 'done',
      isUpload:true
    };   
     this.fileList = this.fileList.concat(imageObj);    
      item.onSuccess!('', item.file!, '');
}
uploadFormData(referenceId,images: any | null) {
   for(let i=0;i<images.length;i++){
     if(images[i].isUpload){
      let data = new FormData();
      data.append("referenceId",referenceId);
      data.append("file", images[i].originFileObj);
      data.append("imageKey", "productImages");
      this.productService.profileImageUpload(data).subscribe((res:any) => {

       },error => {
     });
     }
  }
}
getCategoryList(){
  this.optionsLoading = true;
  let userAppCode = this.authService.getAppCode();
  const value={
  appCode:userAppCode,
  status:1
  }
  this.productService.getCategoryList(value).subscribe((response: any) => {
    this.optionsLoading = false;
     this.categoryOptions=response.data.merchantProductCategoryList;
  }, () => {
    this.optionsLoading = false;
   });
}

 //------------------------------------for thumbnail image ----------------------------------------//
  // get image list
 /* getAttachmentList() {
    const args = {
      referenceId: this.selectedProduct.id,
      pageSize: 1,
      pageIndex: 1,
      type: 'voucher'
    }
    this.voucherService.attachmentList(args).subscribe((response: any) => {
      if (response.data) {
        // this.voucherMerchantsAttachmentList = response.data.attachments;
        this.thumbnailImageId = response.data.attachments[0].id;
        // this.thumbnailImageName = response.data.attachments[0].fileName;
      }
    }, () => {
      this.loadingData = false;
    });
  }*/

  // For thumbnail Image Download
  getThumbnailUrl(imageName): string {
    if (this.selectedProduct) {
      return urls.ProductUrls.thumbnailDownload + this.thumbnailImageName + "/thumbnail";
    } else {
      return this.thumbnailImageSrc;
    }
  }

  // For thumbnail Upload
  onChangeImage(evt: any) {
    const image: any = evt.target.files[0];
    let imgs: any;
    imgs = new Image();
    imgs.src = window.URL.createObjectURL(image);
    this.thumbnailImage = image;
    if (this.selectedProduct) {
      this.notification.info("Loading", "", {
        nzKey: "key",
      });
      this.uploadImage(this.selectedProduct.id, 'update');
    } else {
      this.thumbnailImageSrc = imgs.src;
      this.isThumbnailImage = true;
    }
  }

  uploadImage(id, action) {
    const formData = new FormData();
    formData.append("file", this.thumbnailImage);
    formData.append("referenceId", id);
    // formData.append("type", imageUploadType.voucher);
    formData.append("imageKey", "thumbnail");
    this.productService.thumbnailUpload(formData).subscribe(
      (response: any) => {
        const responseData = response;
        if (responseData && responseData.fileName) {
          this.thumbnailImageName = responseData.fileName;
          this.imageId = responseData.id;  // id is not returned
          this.isThumbnailImage = true;
        }
        if (action === 'create') {
          this.notification.success(Messages.saved, "", {
            nzKey: "key",
          });
          this.onSavedProduct.emit(response); // for closing drawer after image upload in create 
          this.buttonLoading = false;
        }
      },
      (err) => { }
    );
  }


  // Confirmation popup for Delete based on Image Type
  showDeleteConfirmationForImage(imageType, imageName) {
    this.modal.confirm({
      nzTitle: "Are you sure want to delete this thumbnail image?",
      nzOkText: "Yes",
      nzOkType: "danger",
      nzOnOk: () => this.removeImageFromServer(imageType, imageName),
      nzCancelText: "No",
      nzOnCancel: () => console.log("Cancel"),
    });
  }
  // Delete Image API request
  removeImageFromServer(imageType, imageName) {
    if (this.selectedProduct.id) {
      this.productService.thumbnailDelete(this.selectedProduct.id, imageName)
        .subscribe((response: any) => {
          this.notification.success(response.message, "", {
            nzKey: "key",
          });
          imageName = "";
          this.thumbnailImageName = '';
          this.thumbnailImageId = '';
          if (imageType === "thumbnailImage") {
            this.isThumbnailImage = false;
          }
        });
    }
    this.isThumbnailImage = false;
  }

  removeFileFromclient() {
    this.modal.confirm({
      nzTitle: "Are you sure want to delete this thumbnail image?",
      nzOkText: "Yes",
      nzOkType: "danger",
      nzOnOk: () => this.removeImage('yes'),
      nzCancelText: "No",
      nzOnCancel: () => this.removeImage('no'),
    });
  }

  removeImage(remove){
  if(remove == 'yes'){
    this.isThumbnailImage = false; 
    this.thumbnailImage = '';

  }
  }
}



